/**
 * How an inspection's type reads to people. Stored values are `routine`,
 * `rainfall` and `both` (one visit covering the weekly routine AND a required
 * rain event, #265); Jim 2026-10-06: it must say "Rain Event" or "Routine /
 * Rain Event" wherever it prints — "it's literally the word both".
 */
const LABELS: Record<string, string> = {
  both: 'Routine / Rain Event',
  rainfall: 'Rain Event',
  routine: 'Routine',
};

export function inspectionTypeLabel(type: string | null | undefined): string {
  if (!type) return '';
  return (
    LABELS[type] ??
    type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}
